import React, { useState } from 'react';
import { FaRegHandPointLeft, FaSearch } from 'react-icons/fa';
import { Account, AccountType } from 'types/userTypes';
import { fetchCompanyName } from 'utils/enhetsregisteretUtil';
import { AccountFormField, AccountFormFieldError } from './FormField';
import { AccountFormInput } from './FormInput';

interface AccountsFormOrganizationNumberProps {
  account: Account;
  fieldErrors: AccountFormFieldError;
  isValidOrganizationNumber: (companyNumber: string) => boolean;
  syncAccount: (newValue: Partial<AccountType>) => void;
}

export const AccountsFormOrganizationNumber = ({
  account,
  fieldErrors,
  isValidOrganizationNumber,
  ...props
}: AccountsFormOrganizationNumberProps) => {
  const [lookingUpCompanyNumber, setLookingUpCompanyNumber] =
    useState<boolean>(false);
  const [lookupCompanyName, setLookupCompanyName] = useState<string>('');
  const [lookupCompanyFailed, setLookupCompanyFailed] =
    useState<boolean>(false);

  const lookupCompanyNumber = async () => {
    if (!isValidOrganizationNumber(account.companyNumber)) {
      return;
    }
    setLookingUpCompanyNumber(true);
    setLookupCompanyFailed(false);
    setLookupCompanyName('');
    const result = await fetchCompanyName(
      account.companyNumber,
      account.countryCode
    );
    if (result.companyNameFromFetch !== '') {
      if (account.name.trim() === '') {
        props.syncAccount({ name: result.companyNameFromFetch });
      }
      setLookingUpCompanyNumber(false);
      setLookupCompanyFailed(false);
      setLookupCompanyName(result.companyNameFromFetch);
    } else {
      setLookingUpCompanyNumber(false);
      setLookupCompanyFailed(true);
      setLookupCompanyName('');
    }
  };

  const companyNumberValidation = (value: string) => {
    setLookupCompanyName('');
    setLookupCompanyFailed(false);
    return value.replace(/\s/g, '');
  };

  return (
    <>
      <AccountFormField
        id="companyNumber"
        label="Organization number"
        fieldErrors={fieldErrors}
      >
        <div className="edit-account-modal__form-input-button">
          <AccountFormInput
            type="text"
            maxLength={20}
            data-lpignore="true"
            placeholder=""
            name="companyNumber"
            value={account.companyNumber}
            autoComplete="none"
            syncAccount={props.syncAccount}
            validation={companyNumberValidation}
          />
          {account.countryCode === 'NO' && (
            <button
              className="edit-account-modal__form-search"
              onClick={lookupCompanyNumber}
              disabled={lookingUpCompanyNumber}
            >
              <FaSearch />
            </button>
          )}
        </div>
      </AccountFormField>
      <div>
        {!lookingUpCompanyNumber && lookupCompanyName !== '' && (
          <div
            className="edit-account-modal__form-search-result"
            onClick={() => {
              props.syncAccount({ name: lookupCompanyName });
            }}
          >
            <span>Organization found:{'  '}</span>
            <span className="edit-account-modal__form-search-result--highlight">
              {lookupCompanyName}
            </span>
            {'  '}
            <FaRegHandPointLeft />
          </div>
        )}
        {!lookingUpCompanyNumber && lookupCompanyFailed && (
          <span className="edit-account-modal__form-search-result-error">
            Could not find an organization with number {account.companyNumber}.
          </span>
        )}
      </div>
    </>
  );
};
